/*********************************************************************************************************************
 *
 *
 *
 *********************************************************************************************************************/
/* global $,meta */
/* eslint-disable no-var */

/**
 * Handles drawing of cropping + passback to the price calculator. This is a wrapper for JCrop, and abstracts some
 * of the messiness out of PriceCalculator.
 *
 * @param {Integer} iProductId - the ID of the product (so we can get hold of the slider)
 * @return {Object} a public API allowing PriceCalculator the ability to interact with it
 */
function CropTool( iProductId )
{
    var $slider;
    var oCropApi;
    var $image;
    var iImageHeight;
    var iImageWidth;
    var iVictimIdx; // the index of the victim
    var $parent;

    /**
     * Callback function called when the selection is updated by the user. This in turn fires an event with information
     * about the position and size of the crop, expressed as a percentage of the image.
     *
     * @param {HTMLElement} img - the image that we’re munging
     * @param {Object} oSelection - information about the selection
     */
    function fnHandleSelection(img, oSelection)
    {
        // convert
        var oTranslated = {
            left:   Math.round((oSelection.x1 / iImageWidth) * 1000) / 10,
            top:    Math.round((oSelection.y1 / iImageHeight) * 1000) / 10,
            height: Math.round((oSelection.height / iImageHeight) * 1000) / 10,
            width:  Math.round((oSelection.width  / iImageWidth ) * 1000) / 10
        };

        // call
        $slider.trigger('crop', oTranslated);
    }

    /**
     * Sets the aspect ratio of the current selection. This will also focus the current element.
     *
     * @param {Float} fAspectRatio - the current aspect ratio of the selection
     */
    function setAspectRatio( fAspectRatio )
    {
        // work out the aspect ratio of the image…
        var fImageAspect = iImageWidth / iImageHeight;

        // get our basic height + width, plus position
        var iSelectionHeight = iImageHeight;
        var iSelectionWidth  = iImageWidth;
        var iOffX = 0;
        var iOffY = 0;

        // adjust based on aspect ratio
        if (fImageAspect > fAspectRatio)
        {
            iSelectionWidth = iSelectionHeight * fAspectRatio;
            iOffX = (iImageWidth - iSelectionWidth) / 2;
        }
        else
        {
            iSelectionHeight = iSelectionWidth / fAspectRatio;
            iOffY = (iImageHeight - iSelectionHeight) / 2;
        }

        // push, and update
        oCropApi.setOptions({ show: true });
        oCropApi.setSelection( iOffX, iOffY, iOffX + iSelectionWidth, iOffY + iSelectionHeight );
        oCropApi.update();
        $parent.removeClass('-inactive').addClass('-active');
        $('.flex-direction-nav').hide();
        $('.set-crop').removeClass('disabled');
        $('.set-crop-mobile').removeClass('disabled');
        // poke the event handler so the position is updated
        fnHandleSelection( null, oCropApi.getSelection() );
    }

    /**
     * Callback for initDOM
     */
    function finishInitDOM()
    {
        iVictimIdx = $image.data('index');
        iImageWidth = $image[0].width;
        iImageHeight = $image[0].height;

        // write an attribute back to the image’s parent so we can target it with imgAreaSelect
        $parent = $image.parent().addClass('imgAreaSelect__victim__parent').addClass('-inactive').css({ position: 'relative' });

        // instantiate the crop
        oCropApi = $image.imgAreaSelect({
            // bind a handler to the selection end
            onSelectEnd: fnHandleSelection,

            // store the image’s native height/width because we’re doing responsive-fu and it’ll make it easier!
            imageHeight: iImageHeight,
            imageWidth:  iImageWidth,

            // blah!
            x1: 0,
            y1: 0,
            x2: iImageWidth,
            y2: iImageHeight,

            // various other properties that might be helpful
            parent:      '.imgAreaSelect__victim__parent',  // the class we thought of earlier
            resizable:   false, // we don’t want the user to be able to resize
            show:        false, // hide by default
            persistent:  true,  // don’t allow the user to create arbitary crops
            instance:    true   // return an API object for later use
        });

        // finally, stop any lightboxing
        $image.parents('a').on('click', function(ev)
        {
            ev.stopImmediatePropagation();
            return false;
        })
    }

    /**
     * Initialises the DOM.
     *
     * @return {boolean} true on success, false otherwise
     */
    function initDOM()
    {
        // grab the slider
        $slider = $('#product-' + iProductId + '-gallery');
        if ($slider.length === 0)
        {
            return false;
        }

        // grab the first image that we can hijack for our purposes
        $image = $slider.find('img[data-image-id]');
        if ($image.length === 0)
        {
            return false;
        }
        $image = $image.eq(0);

        // wait for it to be loaded
        if ($image[0].complete && ($image.naturalHeight !== 0))
        {
            finishInitDOM();
        }
        else
        {
            $image.on('load', finishInitDOM);
        }

        return true;
    }

    return (function init()
    {
        // set everything up
        if (!initDOM())
        {
            return null;
        }

        // return the public API
        return {
            /**
             * Sets the current crop origin: used when initialising the component.
             *
             * @param {Integer} iX - the horizontal offset (as a percentage)
             * @param {Integer} iY - the vertical offset (as a percentage)
             */
            setOffset: function(iX, iY)
            {
                // get the current offset
                var curr = oCropApi.getSelection();

                // tweak offsets
                iX = Math.round(iImageWidth * iX);
                iY = Math.round(iImageHeight * iY);

                // update stuff
                oCropApi.setSelection(iX, iY, iX + curr.width, iY + curr.height);
                oCropApi.update();

                // call back to update the DOM
                fnHandleSelection( null, oCropApi.getSelection() );
            },

            /**
             * Set the aspect ratio of the crop.
             *
             * @param {Float} fAspect - the aspect ratio.
             */
            setAspectRatio: function(fAspect)
            {
                $slider.flexslider(iVictimIdx);
                setAspectRatio(fAspect);
            },

            /**
             * Event handler.
             *
             * @param {String} sEvt - the name of the event to bind to
             * @param {Function} fCallback - the callback function that will handle the event.
             */
            on: function( sEvt, fCallback ) { $slider.on(sEvt, fCallback); }
        };
    }());
}


/**
 * Handles calculation of price for a given area/quality of the wallpaper. Delegates cropping stuff off to the crop tool.
 *
 * @return {nil} nothing important =)
 */
function PriceCalculator()
{
    var elRoot = this;
    var oEl = {
        qtySelect:  'quality',
        realHeight: 'actualHeight',
        realWidth:  'actualWidth',
        top:        'offset-top',
        left:       'offset-left',
        price:      'price',
        quantity:   'quantity',
        output:     'formattedDimensions',
        outputOth:  'sizeOutput'
    };
    var oDimensionSelect = {};
    var sCurrentDimensionSet = '';
    var fBasePrice = 0;
    var oCropTool;

    var IN2CM = 2.54;
    var FRACTIONS = [ '', '⅛', '¼', '⅜', '½', '⅝', '¾', '⅞' ];

    /**
     * Updates the current quantity.
     *
     * @param {Integer} qty - the new quantity
     */
    function updateQuantity(qty)
    {
        // update things
        oEl.quantity.value = qty;
        $(oEl.quantity).trigger('input');

        // update the add to cart
        $('#addToCart').prop( 'disabled', qty === 0 );
    }

    /**
     * Performs funky rounding of number per user requirements. This means we always round up, and if the difference
     * between input and output is <5, we add another 10.
     *
     * @param {Integer} fInput - the number that will be rounded.
     * @param {Integer} iToNearest - the number to which we want to round our input to the nearest integer multiple
     * @param {Integer} iMargin - how much to add if we’re too close to our mulitplier
     * @return {Integer} the rounded number.
     */
    function roundUp( fInput, iToNearest, iMargin )
    {
        var iReturn = Math.round( fInput / iToNearest ) * iToNearest;

        if (( iReturn - fInput ) < iMargin )
        {
            iReturn += iToNearest;
        }

        return iReturn;
    }

    /**
     * Converts a float to a vulgar fraction.
     *
     * @param {Float} fInput - the float
     * @return {String} the vulgar fraction.
     */
    function toFraction( fInput )
    {
        var iBase = Math.round( fInput );
        var iFrac = Math.round(( fInput % 1.0 ) * FRACTIONS.length );

        return iBase + FRACTIONS[iFrac];
    }

    /**
     * Updates the current selected price + quantity based on the current dimensions + quantity.
     *
     * @return {boolean} whether this has been completed successfully.
     */
    function fnUpdatePrice( bUpdateCrop )
    {
        // 0. work out what we’re doing
        var oCurrentSystem = oDimensionSelect[ sCurrentDimensionSet ];
        bUpdateCrop = ( bUpdateCrop === undefined ) ? true : bUpdateCrop;

        // 1. get the current height + width dimensions
        var fHeight = parseFloat( oCurrentSystem.height.value );
        var fWidth  = parseFloat( oCurrentSystem.width.value );
        if ((fHeight !== fHeight) || (fWidth !== fWidth) || (fWidth <= 0) || (fHeight <= 0)) //eslint-disable-line no-self-compare
        {
            oEl.price.innerHTML = '£'+$('.step-4 .money').attr('content');
            updateQuantity(0);
            return false;
        }

        // 2. update things
        var sSizeStr;
        var sAreaStr;
        var fRealHeight;
        var fRealWidth;
        if ( sCurrentDimensionSet === 'imperial' )
        {
            // a. convert to metric + update the metric fields
            fHeight *= IN2CM;
            fWidth  *= IN2CM;
            oDimensionSelect.metric.height.value = Math.round( fHeight );
            oDimensionSelect.metric.width.value  = Math.round( fWidth  );

            // b. rounding (with metric logic)
            fRealHeight = fHeight = Math.max( roundUp( fHeight, 10, 5 ), 50 );
            fRealWidth  = fWidth  = Math.max( roundUp( fWidth,  10, 5 ), 50 );

            // c. now convert back to imperial for display purposes
            fHeight = fHeight / IN2CM;
            fWidth  = fWidth  / IN2CM;

            // c. update output display + calculate an area (in square inches)
            sSizeStr = toFraction( fWidth ) + '" × ' + toFraction( fHeight ) + '"';
            sAreaStr = Math.round( fHeight * fWidth ) + ' sq. in.';
        }
        else
        {
            // a. update imperial side
            oDimensionSelect.imperial.height.value = Math.round( fHeight / IN2CM );
            oDimensionSelect.imperial.width.value  = Math.round( fWidth  / IN2CM );

            // b. rounding
            fRealHeight = fHeight = Math.max( roundUp( fHeight, 10, 5 ), 50 );
            fRealWidth  = fWidth  = Math.max( roundUp( fWidth,  10, 5 ), 50 );

            // c. update everything else
            sSizeStr = fWidth + '×' + fHeight + 'cm';
            sAreaStr = Math.round(( fRealHeight / 100 ) * ( fRealWidth / 100 ) * 100) / 100 + 'm²';
        }

        // 3. push everything back + update our crop
        oEl.realHeight.value = fRealHeight;
        oEl.realWidth.value  = fRealWidth;
        if ( bUpdateCrop )
        {
            if($('.crop-active').length > 0) {
                
            } else {
                oCropTool.setAspectRatio( fWidth / fHeight );
            }
        }

        // 4. convert to decimetres and calculate an area (rounded) and price
        updateQuantity(Math.ceil(( fRealHeight / 10 ) * ( fRealWidth / 10 )));
        oEl.price.innerHTML = '£' + ( oEl.quantity.value * fBasePrice ).toFixed(2);

        // 5. format some outputs
        oEl.output.value        = sSizeStr;
        oEl.outputOth.innerHTML = sSizeStr + ' (' + sAreaStr + ')';

        // 6. ensure the output block is now shown
        oEl.outputOth.parentNode.style.display = '';

        if($('.cm-width').val() < 49 || $('.cm-height').val() < 49) {
            $(".step-1 .error").removeClass('hide');
            $(".step-1").addClass('error');
            $("#addToCart").prop('disabled', 'true');
            $(".product-name .money").empty()
            $(".product-name .money").append($(".step-4 span.money").clone());
        } else {
            $(".step-1 .error").addClass('hide');
            $(".step-1").removeClass('error');            
            $("#addToCart").removeAttr('disabled');
            $(".product-name .money").empty()
            $(".product-name .money").append($(".step-4 span.money").clone());
        }
    }

    /**
     * Updates the base price of the current print based on the quality selector.
     *
     * @return {boolean} whether this has been completed successfully.
     */
    function fnUpdateBasePrice()
    {
        // get the new price
        var currVariantId = parseInt(oEl.qtySelect.options[ oEl.qtySelect.selectedIndex ].value, 10);
        var aVariant = meta.product.variants.filter(function(c) { return (c.id === currVariantId); });
        if ((aVariant === undefined) || (aVariant.length !== 1))
        {
            oEl.price.innerHTML = '';
            updateQuantity(0);
            return false;
        }

        // update it
        fBasePrice = aVariant[0].price / 100
        return fnUpdatePrice();
    }

    /**
     * Switches between unit systems.
     *
     * @param {Event} ev the event that called us.
     */
    function fnSwitchSystems( ev )
    {
        // 1. get the button
        var elButton = ev.target;
        var sSystem  = elButton.getAttribute( 'data-system' );

        // 2. mess with buttons
        for ( var i = 0; i < elButton.parentNode.children.length; i++ )
        {
            elButton.parentNode.children[i].classList.remove( '-current' );
        }
        elButton.classList.add( '-current' );

        // 3. toggle
        Object.values( oDimensionSelect ).forEach( function(oSel) { oSel.root.classList.remove( '-current' ); });
        oDimensionSelect[ sSystem ].root.classList.add( '-current' );

        // 4. state + update
        sCurrentDimensionSet = sSystem;
        fnUpdatePrice( false );
    }
  
    /**
     * Provides a debounced update process: this is to work around an issue with another module which keeps resetting
     * the public-facing price.
     */
    var _oTo = null;
    function scheduleUpdatePrice()
    {
      clearTimeout( _oTo );
      _oTo = setTimeout( fnUpdatePrice, 200 );
    }

    /**
     * Binds functionality on the various bits of DOM.
     */
    function bindFunctionality()
    {
        // bind to changing the quality
        oEl.qtySelect.addEventListener('input', fnUpdateBasePrice);

        // bind to changing dimensions
        oDimensionSelect.metric.height.addEventListener( 'input', scheduleUpdatePrice );
        oDimensionSelect.metric.width.addEventListener( 'input', scheduleUpdatePrice );

        oDimensionSelect.imperial.height.addEventListener( 'input', scheduleUpdatePrice );
        oDimensionSelect.imperial.width.addEventListener( 'input', scheduleUpdatePrice );

        


        // bind to navigation buttons
        var elButtons = elRoot.querySelectorAll( '[data-pc-component="systemSwitch"]' );
        for ( var i = 0; i < elButtons.length; i++ )
        {
            elButtons[i].addEventListener( 'click', fnSwitchSystems );
        }
        elButtons[0].click();

        // bind to the crop tool changing
        oCropTool.on('crop', function(ev, oSelection)
        {
            if($('.crop-active').length > 0) {
                
            } else {
                oEl.top.value  = oSelection.top;
                oEl.left.value = oSelection.left;
            }
        });

        // load in the current base price
        fnUpdateBasePrice();

        $(".mural-type").click(function() {
            setTimeout( fnUpdateBasePrice, 200 );
        });
    }

    /**
     * Tries to retrieve a state from the query string
     *
     * @return  {boolean} whether or not there was a state to retrieve from the query string
     */
    function checkCurrentState()
    {
        // build a regex
        if ((document.location.search === null) || (document.location.search.indexOf('&edit') === -1))
        {
            return false;
        }

        // start parsing things out
        let oParam = {};
        document.location.search.split('&').forEach(function(p)
        {
            var aM;
            if ((aM = p.match(/^(\w+)(?:=(.*?))?$/)) !== null)
            {
                if (aM[2] === undefined)
                {
                    oParam[aM[1]] = true;
                }
                else if (aM[2].match(/^-?\d+(\.\d+)?$/))
                {
                    oParam[aM[1]] = parseFloat(aM[2]);
                }
                else
                {
                    oParam[aM[1]] = aM[2];
                }
            }
        });
        oDimensionSelect.metric.height.value = oParam.selected_height;
        oDimensionSelect.metric.width.value  = oParam.selected_width;

        // update stuff
        setTimeout(function()
        {
            fnUpdatePrice();
            oCropTool.setOffset( oParam.left / 100, oParam.top / 100 );
        }, 1000);
        return true;
    }

    /**
     * Grabs hooks on all the DOM stuff.
     *
     * @return {boolean} true on success, false otherwise
     */
    function hookDOM()
    {
        // iterate through our elements in the old-fashioned way
        for (var k in oEl)
        {
            // blah
            if (!oEl.hasOwnProperty(k)) { continue; }

            // look for it
            oEl[k] = document.querySelector('[data-pc-component="' + oEl[k] + '"]');
            if (oEl[k] === null)
            {
                return false;
            }
        }

        // grab the slider
        oCropTool = new CropTool(elRoot.getAttribute('data-pc-productid'));
        if (oCropTool === null)
        {
            return false;
        }

        // hide the output block
        oEl.outputOth.parentNode.style.display = 'none';

        // grab our select points
        var elUnits = elRoot.querySelectorAll( '[data-pc-component="units"]' );
        for ( var i = 0; i < elUnits.length; i++ )
        {
            // a. work out what we have
            var el = elUnits[i];
            var sSystem = el.getAttribute( 'data-system' );

            // b. store pointers
            oDimensionSelect[ sSystem ] = {
                root:   el,
                height: el.querySelector( '[data-pc-component="height"]' ),
                width:  el.querySelector( '[data-pc-component="width"]' )
            };
        }

        return true;
    }

    /**
     * Constructor logic
     */
    return (function init()
    {
        // hook the DOM
        if (!hookDOM())
        {
            return false;
        }

        // start binding functionality
        bindFunctionality();

        // update the current state
        if (!checkCurrentState())
        {
            // this is irritating, but apparently Shopify snarfs things otherwise
            setTimeout(function() { updateQuantity(0) }, 500);
        }

    }());
}

$(function()
{
    $('[data-behaviour="priceCalculator"]').each(PriceCalculator);
});
